export const CTA_FORM_LINK =
  "https://api.hsforms.com/submissions/v3/integration/submit/4128655/d87822b8-3a50-40bd-80fb-2f5ee80ec671"

export const HERO_MAIN_FORM_LINK =
  "https://api.hsforms.com/submissions/v3/integration/submit/4128655/12846527-9a91-48bb-9d81-e29fc0d703e8"

export const FEEDBACK_FORM_LINK =
  "https://api.hsforms.com/submissions/v3/integration/submit/4128655/9fc3a95d-9212-4051-8233-1b777e327351"

export const GATE_FORM_LINK =
  "https://api.hsforms.com/submissions/v3/integration/submit/4128655/24d7530d-c277-4fe3-be24-ce29ab4d5e61"

export const SUBSCRIPTION_FORM_LINK =
  "https://api.hsforms.com/submissions/v3/integration/submit/4128655/ee1d1597-6bbc-4b6c-b6b9-ae794a51b091"
